

export default new class NavigationComponent {
  currentStepName: string;
  public steps = [
    {
      title: "Plans",
      name: "Plan",
      number: 0,
    },
    {
      title: "Information",
      name: "Company",
      number: 1,
    },
    {
      title: "Contact Details",
      name: "Contact",
      number: 2,
    },
    {
      title: "Confirmation",
      name: "Thanks",
      number: 3,
    }

  ];

  currentStep(index) {
    const currentStep = this.steps.filter(s => s.name.toLowerCase() == this.currentStepName).pop()!;
    if (index < currentStep.number) return 'pass';
    return index == currentStep.number ? 'active' : '';
  }

}

